import { InlineTeaserView } from '@components'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { FaExclamationTriangle } from 'react-icons/fa'

interface SuggestionCardAlertsProps {
  trialLimitReached: boolean
  isDocumentLimitReached: boolean
  planName: string
  planSettingsUrl: string
  documentLimit: number
}

export const SuggestionCardAlerts: React.FC<SuggestionCardAlertsProps> = ({
  trialLimitReached,
  isDocumentLimitReached,
  planName,
  planSettingsUrl,
  documentLimit
}) => {
  const { t } = useTranslation()

  if (!trialLimitReached && !isDocumentLimitReached) return null

  return (
    <div style={{ width: '100%' }}>
      {trialLimitReached ? (
        <>
          <InlineTeaserView
            icon={<FaExclamationTriangle />}
            iconText={t('document.form.trialLimitReachedTitle')}
            text={t('document.form.trialLimitReachedDescription', { planName })}
            ctaLabel={t('document.form.trialLimitReachedCta')}
            ctaTo={planSettingsUrl}
          />
          <br />
        </>
      ) : isDocumentLimitReached ? (
        <>
          <InlineTeaserView
            icon={<FaExclamationTriangle />}
            iconText={t('document.form.limitReachedTitle')}
            text={t('document.form.limitReachedDescription', { documentLimit })}
          />
          <br />
        </>
      ) : null}
    </div>
  )
}
